"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { authClient } from "@/lib/auth-client";
import { createWebMcpTools, registerWebMcpTools, type WebMCPContext } from "@/lib/webmcp";

/** Navigation and session-guarded reads only; approval remains a human action. */
export function WebMcpTools() {
  const $ = _c(3);
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== router) {
    t0 = () => registerWebMcpTools({
      document: document as Document & {
        modelContext?: WebMCPContext;
      },
      navigator: navigator as Navigator & {
        modelContext?: WebMCPContext;
      }
    }, createWebMcpTools({
      push: path => router.push(path),
      getSession: _temp,
      fetch: _temp2
    }));
    t1 = [router];
    $[0] = router;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}
function _temp2(input, init) {
  return fetch(input, init);
}
function _temp() {
  return authClient.getSession();
}